(function ($) {
  Drupal.behaviors.youtubePreviewPlayerV1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $thismodule = $('.js-youtube-preview-player', context);

      $thismodule.each(function () {
        var $module = $(this);
        var $video = $module.find('video');

        function onVideoOut() {
          $video.get(0).pause();
        }

        function onVideoHover() {
          $video.get(0).play();
        }

        if ($video.length > 0) {
          if (isMobile()) {
            onVideoHover();
          } else {
            if (!$video.attr('autoplay')) {
              $video.hover(onVideoHover, onVideoOut);
            }
          }
        }
      });

      function isMobile() {
        return Unison.fetch.now().name === 'small';
      }
    }
  };
})(jQuery);
